import { render, staticRenderFns } from "./RiskAssessmentDetails.vue?vue&type=template&id=191db53a&scoped=true&"
import script from "./RiskAssessmentDetails.vue?vue&type=script&lang=js&"
export * from "./RiskAssessmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./RiskAssessmentDetails.vue?vue&type=style&index=0&id=191db53a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191db53a",
  null
  
)

export default component.exports